import React, { useState, useEffect, useCallback } from "react";
import Base from "../../components/BaseTemplate";
import { useNavigate } from "react-router-dom";
import useToken from "../../components/utils/token";
import RxnTable from "../../components/RxnTable";
import { Button } from "react-bootstrap";
import { IconAddOutline } from "../../components/SVGs";
import useAPI from "../../components/utils/useAPI";
import { tError } from "../../components/customToast";

const TABLE_COLUMNS = [
  {
    label: "Rxn ID",
    field: "rxn_id",
  },
  {
    label: "Short Name",
    field: "rxn_name",
  },
  {
    label: "Product: Reagents",
    field: "description",
  },
  {
    label: "Rxn SMARTS",
    field: "smarts",
  },
];

export default function Reactions() {
  // States
  const [rxnList, setRxnList] = useState({
    columns: TABLE_COLUMNS,
    data: [],
  });
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);

  // Hooks
  const navigate = useNavigate();
  const { token } = useToken();
  const { apiCall, error } = useAPI();

  // API Calls
  const getTagList = useCallback(async () => {
    try {
      const data = await apiCall({
        method: "GET",
        url: "/reactionClass/tagList",
      });
      setTags(data.tags);
    } catch (error) {
      tError(
        `Error: ${error.name}\n Message: ${error.message}\n Code: ${error.code}`
      );
    }
  }, [apiCall]);

  const getRxns = async () => {
    setLoading(true);
    try {
      const data = await apiCall({
        method: "GET",
        url: "/reactionClass/reactions",
      });
      setRxnList({ ...rxnList, data: data });
      localStorage.setItem("rxnData", JSON.stringify(data));
    } catch (error) {
      tError(
        `Error: ${error.name}\n Message: ${error.message}\n Code: ${error.code}`
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    getTagList();
    if (localStorage.getItem("rxnData")) {
      setRxnList({
        ...rxnList,
        data: JSON.parse(localStorage.getItem("rxnData")),
      });
    } else {
      getRxns();
    }
  }, []);

  // Handle error display
  if (error) {
    return (
      <Base>
        <div className="alert alert-danger" role="alert">
          Error loading data: {error}
        </div>
      </Base>
    );
  }

  return (
    <Base>
      <RxnTable
        striped
        bordered
        hover
        hasTags
        rxnCache
        data={rxnList}
        tags={tags}
        token={token}
        loading={loading}
        actions={{
          view: true,
          viewLogic: (target) => navigate("/reactions/" + target.rxn_id),
          add: true,
          addLogic: () => (
            <Button onClick={() => navigate("/register_reaction")}>
              <IconAddOutline />
            </Button>
          ),
        }}
      ></RxnTable>
    </Base>
  );
}
